import React from "react";
import { Box, Typography, Grid, Container, Stack } from "@mui/material";
import { BsCalendarCheck, BsPersonCheck, BsCheckCircle, BsSliders } from "react-icons/bs";

const steps = [
  {
    title: "Book",
    desc: "Tell us what you need and when you need it done.",
    icon: <BsCalendarCheck />,
  },
  {
    title: "Match",
    desc: "We'll match you with a top-rated pro in your area.",
    icon: <BsPersonCheck />,
  },
  {
    title: "Done",
    desc: "Your pro arrives on time and gets the job done right.",
    icon: <BsCheckCircle />,
  },
  {
    title: "Stay in Control",
    desc: "Track progress, communicate with your pro, and pay securely.",
    icon: <BsSliders />,
  },
];

const HowItWorks = () => {
  return (
    <Box sx={{ backgroundColor: "#fff", py: { xs: 3, md: 5 }, px: { xs: 2, sm: 0 } }}>
      <Container maxWidth="lg">
        <Typography
          sx={{
            fontSize: { xs: "24px", md: "36px" },
            fontWeight: "700",
            color: "#0F2231",
            textAlign: "center",
            mb: { xs: 3, md: 6 },
          }}
        >
          How it works
        </Typography>

        <Grid container spacing={{ xs: 2.5, md: 4 }} justifyContent="center">
          {steps.map((step, index) => (
            <Grid item key={index} xs={6} sm={6} md={3}>
              <Stack alignItems="center" spacing={{ xs: 4, md: 6 }}>
                <Box
                  sx={{
                    width: { xs: 80, sm: 90, md: 100 },
                    height: { xs: 80, sm: 90, md: 100 },
                    borderRadius: "50%",
                    backgroundColor: "#fff7ed",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#F15A24",
                    fontSize: { xs: "36px", md: "40px" },
                  }}
                >
                  {step.icon}
                </Box>
                <Typography
                  sx={{
                    fontSize: { xs: "13px", md: "16px" },
                    fontWeight: 700,
                    color: "#0F2231",
                    textAlign: "center",
                    maxWidth: "280px",
                    lineHeight: 1.5,
                  }}
                >
                  {step.desc}
                </Typography>
              </Stack>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default HowItWorks;
